import { Box, Flex, Text } from "@chakra-ui/react";
import { Pedido as IPedido } from "../../utils/interfaces";
import { formatBRL } from "../../utils/currency";

interface Props {
  pedido: IPedido
  totalTaxaCancelamentoRetida?: number
}

export function Pedido({pedido, totalTaxaCancelamentoRetida = 0}: Props){
  return (
    <Box w={'full'} bg={'white'} p={'2'} display={'flex'} flexDir={'column'}>
      <Box
          width={"full"}
          fontSize={"sm"}
          border={"1px solid #ccc"}
          display={"flex"}
          flexDir={"column"}
        >
        <Box
            mt={"-2"}
            ml={1}
            fontWeight={"bold"}
            bg={"white"}
            as={"span"}
            w={"150px"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            Resumo da Viagem
          </Box>
          <Flex flexDir={'column'} px={'8'} py={'4'} maxWidth={{xs: '100%', lg: '40%'}}>
            <Text fontWeight={'bold'}>Detalhes do Pedido</Text>
            <Flex justifyContent={'space-between'}>
              <Text >Código do Pedido:</Text>
              <Text>{pedido.id}</Text>
            </Flex>
            <Flex justifyContent={'space-between'}>
              <Text >Usuário:</Text>
              <Text>{pedido.usuario}</Text>
            </Flex>
            <Flex justifyContent={'space-between'}>
              <Text >Empresa:</Text>
              <Text>{pedido.agencia}</Text>
            </Flex>
            <Flex justifyContent={'space-between'}>
              <Text >Status:</Text>
              <Text
                fontWeight={'bold'}
                color={
                  pedido.status_label === "CANCELADO" ? 'red.400' :
                  (pedido.status_label === "DEVOLVIDO" || pedido.status_label === "DEVOLVIDO PARCIALMENTE" ? 'red.500' :
                  pedido.status_label === "CONTESTADO" ? 'orange.500' : '')
                }
              >
                {pedido.status_label}
              </Text>
            </Flex>
            <Flex justifyContent={'space-between'}>
              <Text >Data do Pedido:</Text>
              <Text>{pedido.created_at}</Text>
            </Flex>
            <Flex justifyContent={'space-between'}>
              <Text >Forma de Pagamento:</Text>
              <Text>{pedido.forma_pagamento_label}</Text>
            </Flex>
            <Flex justifyContent={'space-between'}>
              <Text >Total do Pedido:</Text>
              <Text fontWeight={'bold'} textTransform={'uppercase'}> {formatBRL(Number(pedido.valor_total))}</Text>
            </Flex>
            {totalTaxaCancelamentoRetida > 0 && (
              <Flex justifyContent={'space-between'}>
                <Text>Taxa de Cancelamento Retida:</Text>
                <Text fontWeight={'bold'} color={'red.500'}>
                  {formatBRL(totalTaxaCancelamentoRetida)}
                </Text>
              </Flex>
            )}
          </Flex>
      </Box>
    </Box>
  )
}
